import { memo, useState } from 'react'
import { SERVICE_LIST, tab_button, active_tab_button } from '../../../../../functions/stateList'
import ServiceTable from '../../../../tabels/ServiceTable'

function ServicesTab({ services, current_km }) {
  const [activeId, setActiveId] = useState(1)
  const [activeTitle, setActiveTitle] = useState('oil')
  const showServiceHandler = (id) => {
    setActiveId(id)
    if (id === 1) {
      setActiveTitle('oil')
    } else if (id === 2) {
      setActiveTitle('mechanics')
    } else if (id === 3) {
      setActiveTitle('rubber')
    } else if (id === 4) {
      setActiveTitle('cleanliness')
    }
  }
  return (
    <>
      <div className="flex flex-wrap items-center whitespace-nowrap mb-8">
        {SERVICE_LIST.length > 0 &&
          SERVICE_LIST.map(({ id, title }) => (
            <button
              className={activeId === id ? active_tab_button : tab_button}
              key={id}
              onClick={() => showServiceHandler(id)}
            >
              {title}
            </button>
          ))}
      </div>

      <ServiceTable current_km={current_km} activeTitle={activeTitle} services={services} />
    </>
  )
}

export default memo(ServicesTab)
